import { AppContext } from '../pixeltrade/models/app.context';
import { OrderContext } from '../pixeltrade/models/order-context.state';
import { TrendStockContext } from '../pixeltrade/models/trend-stock.state';

export const TREND_STOCK_CONTEXT = 'trendstock/CONTEXT';
export const ORDER_CONTEXT = 'order/CONTEXT';
export const APP_CONTEXT = 'app/CONTEXT';

export function trendstockContext(trendstockState: TrendStockContext) {
    return {
        type: TREND_STOCK_CONTEXT,
        trendstockState
    };
}

export function orderContext(orderState: OrderContext) {
    return {
        type: ORDER_CONTEXT,
        orderState
    };
}

export function appContext(context: AppContext) {
    return {
        type: APP_CONTEXT,
        context
    };
}